
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/notification",
      function () {
        return require("private-next-pages/default/desktop/notification.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/notification"])
      });
    }
  